module.exports = __webpack_public_path__ + "static/media/nearbuyPreview.6fe7eb55.jpg";